<template>
  <div v-if="isQuestionView">
    <hr-field-question-view :value="value" />
  </div>
  <div v-else-if="shouldShowDefaultView">
    <hr-field-default-view
      :value="value"
      :is-sensitive-hidden="isSensitiveHidden"
      :owner="owner"
    />
  </div>
</template>

<script>
import { reactive, computed } from 'vue';
import t from '@/lib/i18next';
import { QUESTION_FIELD_TYPE } from '@/core/input-types/custom_questions';
import HrFieldQuestionView from '@/components/hr-field-question-view';
import HrFieldDefaultView from '@/components/hr-field-default-view';

export default {
  name: 'hr-field-view',
  components: { HrFieldQuestionView, HrFieldDefaultView },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    owner: {
      type: Boolean,
      default: false,
    },
    isSensitiveHidden: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const state = reactive({
      theField: props.value,
      rules: {
        visible: !props.value.hide,
      },
    });

    const shouldShowDefaultView = computed(
      () => state.theField.type !== 'CONTENT' && state.rules.visible
    );

    const isQuestionView = computed(() => isQuestionType(state.theField.type));

    function isQuestionType(type) {
      return type === QUESTION_FIELD_TYPE;
    }

    return {
      t,
      state,
      shouldShowDefaultView,
      isQuestionView,
    };
  },
};
</script>

<style lang="scss">
@import '~@/core/style-vars.scss';

.hr-field-view {
  text-align: left;
  margin: 0 6px;
  padding: 12px 0;
  display: grid;
  align-items: center;
  grid-template-columns: 300px auto auto;
  grid-gap: 16px;
  border-bottom: 1px solid var(--dpt-border-color);

  @media only screen and (max-device-width: 768px) {
    grid-template-columns: 50% auto auto;
  }
}

.hr-field-view__title {
  color: var(--dpt-text-color);
  font-weight: $font-weight-bold;
  margin-right: 8px;
}

.hr-field-view__value {
  color: var(--dpt-text-color);
  word-break: break-all;
}

.hr-field-view__value-view {
  cursor: pointer;
}
</style>
